/* vmx-reviews.js — Client-side filtering, sorting, pagination for review section. */

(function() {
  const container = document.querySelector('[data-reviews-container="true"]');
  if (!container) return;

  const grid = container.querySelector('[data-reviews-grid="true"]');
  const filters = container.querySelectorAll('[data-product-filter]');
  const sortSelect = container.querySelector('[data-sort-select="true"]');
  const loadMoreBtn = container.querySelector('[data-load-more-btn="true"]');
  const clearBtn = container.querySelector('[data-clear-filter="true"]');
  const clearAllBtn = container.querySelector('[data-clear-all="true"]');
  const emptyState = container.querySelector('[data-empty-state="true"]');
  const loadMoreSection = container.querySelector('[data-load-more="true"]');

  const PAGE_SIZE = 18;
  let activeProduct = 'all';
  let activeStars = null;
  let sortBy = 'newest';
  let visibleCount = PAGE_SIZE;

  const allReviews = Array.from(grid.querySelectorAll('[data-review-id]'));

  function getFilteredReviews() {
    let list = [...allReviews];
    if (activeProduct !== 'all') {
      list = list.filter(r => r.dataset.productSlug === activeProduct);
    }
    if (activeStars !== null) {
      list = list.filter(r => parseInt(r.dataset.stars) === activeStars);
    }
    if (sortBy === 'newest') {
      list.sort((a, b) => parseInt(b.dataset.reviewId) - parseInt(a.dataset.reviewId));
    } else if (sortBy === 'highest') {
      list.sort((a, b) => parseInt(b.dataset.stars) - parseInt(a.dataset.stars));
    } else {
      list.sort((a, b) => parseInt(a.dataset.stars) - parseInt(b.dataset.stars));
    }
    return list;
  }

  function renderStars(containerEl, count) {
    while (containerEl.firstChild) {
      containerEl.removeChild(containerEl.firstChild);
    }
    for (let i = 1; i <= 5; i++) {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('width', '14');
      svg.setAttribute('height', '14');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      const poly = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
      poly.setAttribute('points', '12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26');
      poly.setAttribute('fill', i <= count ? '#fbcd0a' : '#e5e7eb');
      svg.appendChild(poly);
      containerEl.appendChild(svg);
    }
  }

  function renderGrid() {
    const filtered = getFilteredReviews();
    const visible = filtered.slice(0, visibleCount);

    allReviews.forEach(r => r.style.display = 'none');
    visible.forEach(r => r.style.display = 'flex');

    updateCount(visible.length, filtered.length);
    updateLoadMore(filtered.length);
    updateEmptyState(filtered.length === 0);
    updateClearBtn();
  }

  function updateCount(shown, total) {
    const countEl = container.querySelector('[data-review-count="true"]');
    if (countEl) {
      const visibleEl = countEl.querySelector('[data-visible]');
      const totalEl = countEl.querySelector('[data-total]');
      if (visibleEl) visibleEl.textContent = shown.toString();
      if (totalEl) totalEl.textContent = total.toString();
    }
  }

  function updateLoadMore(total) {
    const hasMore = visibleCount < total;
    loadMoreSection.style.display = hasMore ? 'block' : 'none';
    if (hasMore) {
      const moreEl = container.querySelector('[data-more-count="true"]');
      const count = total - visibleCount;
      if (moreEl) {
        const noun = count !== 1 ? 's' : '';
        moreEl.textContent = count + ' more review' + noun + ' to load';
      }
    }
  }

  function updateEmptyState(isEmpty) {
    emptyState.style.display = isEmpty ? 'block' : 'none';
  }

  function updateClearBtn() {
    const visible = activeStars !== null;
    clearBtn.style.display = visible ? 'inline-flex' : 'none';
    if (visible) {
      const labelEl = clearBtn.querySelector('[data-filter-label]');
      if (labelEl) labelEl.textContent = activeStars + '★ only';
    }
  }

  filters.forEach(btn => {
    btn.addEventListener('click', () => {
      const slug = btn.dataset.productFilter;
      activeProduct = slug;
      visibleCount = PAGE_SIZE;
      activeStars = null;
      filters.forEach(b => b.classList.toggle('vmx-reviews-filter-active', b.dataset.productFilter === slug));
      renderGrid();
    });
  });

  sortSelect.addEventListener('change', (e) => {
    sortBy = e.target.value;
    renderGrid();
  });

  loadMoreBtn.addEventListener('click', () => {
    visibleCount += PAGE_SIZE;
    renderGrid();
  });

  clearBtn.addEventListener('click', () => {
    activeStars = null;
    visibleCount = PAGE_SIZE;
    renderGrid();
  });

  clearAllBtn.addEventListener('click', () => {
    activeProduct = 'all';
    activeStars = null;
    visibleCount = PAGE_SIZE;
    filters.forEach(b => b.classList.toggle('vmx-reviews-filter-active', b.dataset.productFilter === 'all'));
    renderGrid();
  });

  const starDistBtns = container.querySelectorAll('[data-star-filter]');
  starDistBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const star = parseInt(btn.dataset.starFilter);
      activeStars = activeStars === star ? null : star;
      visibleCount = PAGE_SIZE;
      starDistBtns.forEach(b => b.setAttribute('aria-pressed', 'false'));
      if (activeStars) btn.setAttribute('aria-pressed', 'true');
      renderGrid();
    });
  });

  container.querySelectorAll('.vmx-reviews-stars').forEach(el => {
    const stars = parseInt(el.dataset.stars) || 5;
    renderStars(el, stars);
  });

  // Deep-link support: /pages/reviews?product=<handle> pre-filters the grid
  // and scrolls to the per-product anchor. Triggered from PDP/BDP rating row.
  try {
    const params = new URLSearchParams(window.location.search);
    const wanted = params.get('product');
    if (wanted) {
      const match = Array.from(filters).find(b => b.dataset.productFilter === wanted);
      if (match) {
        activeProduct = wanted;
        visibleCount = PAGE_SIZE;
        filters.forEach(b => b.classList.toggle('vmx-reviews-filter-active', b.dataset.productFilter === wanted));
        // Defer scroll until after render so anchor offset is correct
        requestAnimationFrame(() => {
          const anchor = document.getElementById('vmx-reviews-for-' + wanted);
          if (anchor) anchor.scrollIntoView({behavior: 'smooth', block: 'start'});
        });
      }
    }
  } catch (e) { /* no-op */ }

  renderGrid();
})();
